import {
  ChangeEvent,
  DynamicContentType,
  YtVideoData,
} from '@bm-js/atlascloud-shared'
import Input from './Input'
import Select from './Select'
import { marginOptions } from '@bm-js/atlascloud-ui'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<YtVideoData>
  setData: (e: ChangeEvent) => void
}

const YTVideoEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  return (
    <>
      <Input
        type='text'
        label={tr(TrKey.ytVideoEditorUrlLabel)}
        desc={tr(TrKey.ytVideoEditorUrlDescription)}
        value={content.data.url}
        onChange={setData}
        id='url'
        name='url'
      />
      <Select
        light
        label={tr(TrKey.ytVideoEditorMarginBottomLabel)}
        desc={tr(TrKey.ytVideoEditorMarginBottomDescription)}
        id='marginBottom'
        name='marginBottom'
        value={content.data.marginBottom}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.ytVideoEditorMarginBottomPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
    </>
  )
}

export default YTVideoEditor
